import { initialMfaState, MfaErrors } from './mfa.state';
import { createReducer, on } from '@ngrx/store';
import * as MfaActions from './mfa.actions';
import { switchToProduct } from '../user-session/user-session.actions';

export const mfaReducer = createReducer(
  initialMfaState,
  on(MfaActions.getIsMfaEnabled, (state) => ({
    ...state,
    isLoading: true,
    hasFailed: false,
  })),
  on(
    MfaActions.promptMfa,
    (state, { originProduct, originUrl, twoFactorType }) => ({
      ...state,
      isLoading: false,
      hasFailed: false,
      twoFactorType,
      originProduct: {
        ...originProduct,
        loginUrl: originUrl || originProduct.loginUrl,
      },
    }),
  ),
  on(MfaActions.mfaError, (state, { errorType, originUrl }) => {
    const newState = { ...state, isLoading: false, hasFailed: true };
    if (errorType) {
      newState.errorType = errorType;
    }
    if (errorType === MfaErrors.IS_EMAIL_MISSING) {
      newState.originProduct = {
        ...state.originProduct,
        loginUrl: originUrl || null,
      };
    }
    return newState;
  }),
  on(MfaActions.dismissMfaError, (state) => ({
    ...state,
    hasFailed: false,
  })),
  on(MfaActions.authenticateMfaCode, (state) => ({
    ...state,
    isLoading: true,
  })),
  on(MfaActions.navigateToOrigin, (state) => ({
    ...state,
    isLoading: true,
  })),
  on(switchToProduct, (state) => ({
    ...state,
    isLoading: true,
  })),
);
